/**
 * Interruptor "Novidades do grupo" (PO, 22/09/2026). Vive no Perfil, ao lado
 * dos alertas — mas é POR CONTA: desligou, nenhum aparelho seu recebe. Chegar
 * de fato depende dos alertas deste aparelho estarem ligados (o push é o
 * mesmo); a nota explica isso quando for o caso.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

import { type EstadoDosAlertas, estadoDosAlertas } from './push';

async function ler(): Promise<{ enabled: boolean }> {
  const res = await fetch('/api/v1/me/group-news', { credentials: 'same-origin' });
  if (!res.ok) throw new Error('Não foi possível ler a preferência.');
  return (await res.json()) as { enabled: boolean };
}

async function gravar(enabled: boolean): Promise<{ enabled: boolean }> {
  const res = await fetch('/api/v1/me/group-news', { method: 'PUT', credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ enabled }) });
  if (!res.ok) throw new Error('Não foi possível mudar a preferência.');
  return (await res.json()) as { enabled: boolean };
}

export function NovidadesDoGrupo() {
  const cliente = useQueryClient();
  const pref = useQuery({ queryKey: ['me', 'group-news'], queryFn: ler, staleTime: 60_000 });
  const [push, setPush] = useState<EstadoDosAlertas | 'carregando'>('carregando');
  useEffect(() => {
    void estadoDosAlertas().then(setPush).catch(() => setPush('indisponivel'));
  }, []);
  const mudar = useMutation({
    mutationFn: gravar,
    onSuccess: (r) => cliente.setQueryData(['me', 'group-news'], r),
  });

  const ligado = pref.data?.enabled ?? true;
  const semPushAqui = push !== 'carregando' && push !== 'ligado';
  return (
    <div className="novidades" data-testid="novidades">
      <div className="alertas__linha">
        <span className="mapa__pessoa-texto">
          <span className="mapa__pessoa-nome">Novidades do grupo</span>
          <span className="mapa__pessoa-familia">
            {ligado
              ? 'Quem entrou, o que sugeriram, quem lidera, bom dia às 8h. Bem-humorado e sem exagero.'
              : 'Você não recebe as novidades do grupo. Alertas de atividade continuam à parte.'}
            {ligado && semPushAqui ? ' Ligue os alertas neste aparelho para receber.' : ''}
          </span>
        </span>
        <button
          type="button"
          role="switch"
          aria-checked={ligado}
          aria-label="Novidades do grupo"
          className={`mapa__toggle${ligado ? ' mapa__toggle--on' : ''}`}
          disabled={pref.isLoading || mudar.isPending}
          onClick={() => mudar.mutate(!ligado)}
          data-testid="novidades-toggle"
        >
          <span className="mapa__toggle-bola" />
        </button>
      </div>
      {mudar.isError && <p className="auth-error" role="alert">{(mudar.error as Error).message}</p>}
    </div>
  );
}
